import 'owl.carousel/dist/owl.carousel';

export default class Slider {
    constructor(element, options) {
        this.element = jQuery(element);
        this.options = {
            margin: 0,
            responsiveClass: true,
            loop: true,
            dots: true,
            autoplay: false,
            items: 1,
            autoplayTimeout: 4000,
            autoplaySpeed: 2000,
            animateOut: false,
        };
        jQuery.extend(this.options, options);

        if (this.element.find('div.slide').length > 1) {
            this.element.find('.owl-carousel').owlCarousel(this.options);
        } else {
            this.element.find('.owl-carousel').show();
            this.element.find('.owl-carousel').css('display', 'inline-block');
        }
    }
}


// WEBPACK FOOTER //
// ./scripts/app/slider.js